import styled, { css } from "styled-components";
export const centeredFlex = css`
  display: flex;
  justify-content: start;
  align-items: center;
`;
export const WorkContent = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 0px;
  border-radius: 6px;
  margin-bottom: 10px;
`;
